import { Box, Button, ButtonGroup } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useMemo, useRef } from "react";
import { theme } from "../styles/theme";
import BandDetail from "./BandDetail";
import BandsList from "./BandsList";
import PointDetail from "./PointDetail";
import PointsList from "./PointsList";

export default function SidebarContainer({
  regions,
  markers,
  bands,
  currentView,
  handleLocationSelected,
  sidebarOpen,
  setSidebarOpen,
  setView,
  showViewSwitch = true,
  pointDetail,
  showBandDetails,
  setShowBandDetails,
  handlePointDetailClosed,
  handleBandDetailClosed,
  selectedLocation,
  selectedRegion,
  setSelectedBand,
  selectedBand,
}) {
  const scrollableContainerRef = useRef();

  const allBands = useMemo(() => {
    if (false) {
      // Set to true to disable view and hide all bands
      return [];
    }

    if (!regions) {
      return;
    }

    return regions.reduce((all, region) => {
      return [...all, ...(region.popboard_bands ?? [])];
    }, []);
  }, [regions]);

  return (
    <Box sx={sidebarWrapperStyles}>
      <Box sx={SidebarStyles(sidebarOpen)} ref={scrollableContainerRef}>
        {showViewSwitch && (
          <Box className="locations-bands-toggle">
            <ButtonGroup
              variant="locations-bands-toggle"
              size="small"
              aria-label="primary button group"
            >
              <Button
                className={`locations ${
                  currentView === "locations" && "locations-active"
                }`}
                onClick={() => setView("locations")}
              >
                Pop-Landschaft
              </Button>
              <Button
                className={`bands ${currentView === "bands" && "bands-active"}`}
                onClick={() => setView("bands")}
              >
                Musiker*innen
              </Button>
            </ButtonGroup>
          </Box>
        )}
        {currentView === "locations" ? (
          <>
            {pointDetail ? (
              <PointDetail
                selectedLocation={selectedLocation}
                handlePointDetailClosed={handlePointDetailClosed}
              />
            ) : (
              <PointsList
                locations={markers}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                onLocationSelected={handleLocationSelected}
              />
            )}
          </>
        ) : (
          <>
            {showBandDetails ? (
              <BandDetail
                handleBandDetailClosed={handleBandDetailClosed}
                selectedBand={selectedBand}
              />
            ) : (
              <BandsList
                bands={selectedRegion ? bands : allBands}
                selectedRegion={selectedRegion}
                setSelectedBand={setSelectedBand}
                setSidebarOpen={setSidebarOpen}
                showBandDetails={showBandDetails}
                setShowBandDetails={setShowBandDetails}
                scrollableContainerRef={scrollableContainerRef}
              />
            )}
          </>
        )}
      </Box>
    </Box>
  );
}

const sidebarWrapperStyles = {
  position: "relative",
  height: "100%",
};

const SidebarStyles = (sidebarOpen) => {
  return {
    display: sidebarOpen ? "block" : "none",
    zIndex: "60",
    backgroundColor: grey[900],
    height: "100%",
    width: "90%",
    top: "0",
    left: "0",
    position: "absolute",
    overflowY: "scroll",
    overflowX: "hidden",
    boxShadow:
      "rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px",
    borderRightStyle: "solid",
    borderRightWidth: "2px",
    borderRightColor: grey[700],
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },

    "& .locations-bands-toggle": {
      display: "flex",
      justifyContent: "center",
      backgroundColor: grey[800],
    },
  };
};
